import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ApiError } from '@/lib/apiErrors';
import { SignInAgainButton } from './SignInAgainButton';

/**
 * A load the server answered with 401 (a token it no longer accepts, or a refresh that failed) can't
 * be fixed by "Try again". Shown above the page until any query succeeds again.
 */
export function SessionEndedNotice() {
  const queryClient = useQueryClient();
  const [ended, setEnded] = useState(false);

  useEffect(
    () =>
      queryClient.getQueryCache().subscribe((event) => {
        if (event.type !== 'updated') return;
        const { action } = event;
        if (action.type === 'error' && action.error instanceof ApiError && action.error.status === 401) {
          setEnded(true);
        } else if (action.type === 'success') {
          setEnded(false);
        }
      }),
    [queryClient]
  );

  if (!ended) return null;
  return (
    <div
      role="alert"
      data-session-ended
      className="mb-4 flex items-center justify-between gap-3 rounded-lg border border-red-200 bg-red-50 px-4 py-2 text-sm font-medium text-red-800"
    >
      <span>You're signed out. Sign in again to load this page.</span>
      <SignInAgainButton className="shrink-0" />
    </div>
  );
}
